import { ResourceUserBadges } from "@/components/resource-user-badges";
import { Badge } from "@/components/ui/badge";
import type { DeliveryNote } from "@/types";
import { formatDateAR } from "@/utils/date";

interface DeliveryNoteHeaderProps {
  deliveryNote: DeliveryNote;
  status: { label: string; variant: "outline" | "default" | "secondary" };
}

export default function DeliveryNoteHeader({
  deliveryNote,
  status,
}: DeliveryNoteHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4">
      <div className="space-y-1">
        <h1 className="text-3xl font-semibold tracking-tight">
          {deliveryNote.number ?? `Remito #${deliveryNote.id}`}
        </h1>
        <p className="text-sm text-muted-foreground">
          Recibido el {deliveryNote.receipt_date ? formatDateAR(deliveryNote.receipt_date) : "-"}
        </p>
        <ResourceUserBadges
          createdBy={deliveryNote.created_by}
          reviewedBy={deliveryNote.reviewed_by}
        />
      </div>
      <Badge variant={status.variant}>
        {status.label}
      </Badge>
    </div>
  );
}
